import { EMPTY_TEXT } from '@mitchell/react.component.ux';
import { EnterpriseDocStoreService } from "../../common";
import { QuestionnaireEnum } from "../../questionnaireEvaluation";
import { IntelligentPhotoCaptureViewType, PhotoCaptureAttributeType } from '../enums';
import { shouldEnableOCR } from '../utilities';
export const photoCaptureIsQuestionnaireUpdatedReducer = (state, isQuestionnaireUpdated) => {
    return Object.assign(Object.assign({}, state), { isQuestionnaireUpdated, view: IntelligentPhotoCaptureViewType.NONE });
};
export const photoCapturePreviousQuestionnaireAnsweredReducer = (state, isQuestionnaireUpdated, action) => {
    let screenView;
    let capturedPhotoFileId = '';
    let files = [];
    const { answerList = [], questionAttributeType = '', answrControlType = '' } = action.payload;
    const isPreviousQuestion = !!(answerList && answerList.length && answerList[0].answered);
    const shouldAllowMitchellIntelligentPhotoCapture = !!(state.personaConfiguration && state.personaConfiguration.shouldAllowMitchellIntelligentPhotoCapture);
    let ocrInfo = {
        ocrText: '',
        errorMessage: ''
    };
    if (isPreviousQuestion && answrControlType === QuestionnaireEnum.ADD_ATTACHMENT) {
        const { answerDisplayText } = answerList[0];
        if (answerDisplayText) {
            const parsedAnswer = JSON.parse(answerDisplayText);
            if (parsedAnswer && parsedAnswer[0]) {
                files = [
                    {
                        id: parsedAnswer[0].id,
                        fileName: parsedAnswer[0].imageName,
                        docId: parsedAnswer[0].documentId,
                        docUID: parsedAnswer[0].fileId,
                        thumbnail: {
                            docUID: parsedAnswer[0].thumbFileId
                        },
                        description: parsedAnswer[0].fileDescription
                    }
                ];
                capturedPhotoFileId = parsedAnswer[0].thumbFileId;
                ocrInfo.ocrText = parsedAnswer[0].ocrText || '';
            }
        }
    }
    if (shouldAllowMitchellIntelligentPhotoCapture && shouldEnableOCR(questionAttributeType) && isPreviousQuestion) {
        screenView = IntelligentPhotoCaptureViewType.COMMENT;
    }
    else {
        screenView = IntelligentPhotoCaptureViewType.NONE;
    }
    const lastScreenView = (questionAttributeType === PhotoCaptureAttributeType.VIN_CAPTURE &&
        state.personaConfiguration &&
        state.personaConfiguration.shouldAllowVinDecode &&
        IntelligentPhotoCaptureViewType.VIN_DECODE) ||
        IntelligentPhotoCaptureViewType.PREVIEW;
    return Object.assign(Object.assign({}, state), { isQuestionnaireUpdated, view: screenView, lastRenderedView: lastScreenView, capturedPhoto: {
            docUID: capturedPhotoFileId,
            url: EnterpriseDocStoreService.createFileUrl(capturedPhotoFileId),
            isSelected: false,
            file: undefined
        }, shouldMoveToNextQuestion: false, screenName: EMPTY_TEXT, files,
        ocrInfo });
};
//# sourceMappingURL=photoCaptureIsQuestionnaireUpdatedReducer.js.map